import { encodingTool } from '../util';
export function transformInitData(initData, contentId, certificate) {
    var contentIdBuffer = encodingTool.utf16.toUint16Array(contentId);
    // Format:
    // [initData]
    // [4 byte: idLength]
    // [idLength byte: id]
    // [4 byte:certificateLength]
    // [certificateLength byte: certificate]
    var size = initData.byteLength + 4 + contentIdBuffer.byteLength + 4 + certificate.byteLength;
    var offset = 0;
    var buffer = new ArrayBuffer(size);
    var dataView = new DataView(buffer);
    var initDataArray = new Uint8Array(buffer, offset, initData.byteLength);
    initDataArray.set(initData);
    offset += initDataArray.byteLength;
    dataView.setUint32(offset, contentIdBuffer.byteLength, true);
    offset += 4;
    var idArray = new Uint16Array(buffer, offset, contentIdBuffer.length);
    idArray.set(contentIdBuffer);
    offset += idArray.byteLength;
    dataView.setUint32(offset, certificate.byteLength, true);
    offset += 4;
    var certificateArray = new Uint8Array(buffer, offset, certificate.byteLength);
    certificateArray.set(certificate);
    return new Uint8Array(buffer, 0, buffer.byteLength);
}
export function getContentId(initData) {
    var _a, _b, _c;
    var asString = encodingTool.utf16.fromTypeArray(initData);
    var contentId = (_c = (_b = (_a = asString.split('skd://')) === null || _a === void 0 ? void 0 : _a[1]) === null || _b === void 0 ? void 0 : _b.split('?')) === null || _c === void 0 ? void 0 : _c[0];
    return contentId;
}
